import notifyHB from '@/config/notifyHB';
import { DocumentAuditLog } from '@/entities/document-audit-log';
import { Certificate } from '../entities/certificate';
import { http } from '../http';

export async function getDocumentLog(
	certificateSerial: Certificate['certificate_id'],
) {
	try {
		const documentLogsResponse = await http.get<DocumentAuditLog[]>(
			`documents/${certificateSerial}/logs`,
		);
		if (documentLogsResponse) {
			return documentLogsResponse;
		} else {
			throw new TypeError('Response to GET document log was not valid');
		}
	} catch (exception) {
		notifyHB(
			'use-case',
			'getDocumentLog',
			`Failed to get document log with ${exception}`,
		);
		throw exception;
	}
}
